export enum DashboardElementType {
    Tasks = 'tasks',
    Documents = 'documents',
    Reports = 'reports',
    Incidents = 'incidents',
    Corrections = 'corrections',
    Risks = 'risks',
    RiskControls = 'risk_controls',
}